import { useMemo } from 'react';

import { getCloudFilesContainerUrl } from '@libs/NwUtils';

import useLayoutConfigurations from '@hooks/Configurations/UseLayoutConfiguration';

const DEFAULT_LOGO_PATH = 'tenantassets/logo.png';

const isAbsoluteLogoUrl = (value) => {
    return /^(https?:)?\/\//i.test(value) || value.startsWith('data:');
};

const resolveLogoUrl = (logoValue, cloudFilesContainerUrl) => {
    const normalizedLogoValue = `${logoValue || ''}`.trim();

    if (!normalizedLogoValue) {
        return '';
    }

    if (isAbsoluteLogoUrl(normalizedLogoValue)) {
        return normalizedLogoValue;
    }

    return `${cloudFilesContainerUrl}/${normalizedLogoValue.replace(/^\/+/, '')}`;
};

const useLogo = (logoValue = null, options = {}) => {
    const { fallbackToDefault = true } = options;
    const layoutConfigurations = useLayoutConfigurations();

    const defaultLogoValue =
        layoutConfigurations && layoutConfigurations.logoUrl ? layoutConfigurations.logoUrl : DEFAULT_LOGO_PATH;
    const cloudFilesContainerUrl = getCloudFilesContainerUrl();

    return useMemo(() => {
        const normalizedLogoValue = `${logoValue || ''}`.trim();
        const effectiveLogoValue = normalizedLogoValue || (fallbackToDefault ? defaultLogoValue : '');

        return resolveLogoUrl(effectiveLogoValue, cloudFilesContainerUrl);
    }, [cloudFilesContainerUrl, defaultLogoValue, fallbackToDefault, logoValue]);
};

export default useLogo;
